import { AxiosInstance } from "../helpers/AxiosInstance";

import Config from "../config";

export const IntegrationSetupService = {
    MicrosoftTeams_Code: 'MSTEAMS',
    ClioIntegration_Code: 'CLIO',
    TeamsActivityFeed_Code: 'TAFN',
    HubSpotIntegration_Code: "HSI",
    Slack: "SLACK",
    OutlookIntigration_code: "OUTLOOK",
    WebForm:"WEBFORM",


    updateConsentDetails,
    updateIntegratedChannelDetails,
    getIntegratedChannelDetails,
    getIntegratedAllChannelDetails,
    deleteIntegratedChannel,
    testChannelIntegration,
    getAllIntegrations,
    updateIntegrationStatus,
    disConnectClio,
    disConnectHubSpot,
    getClioToken,
    installSlack,
    testSlackChannelIntegration,
    getSlackIntegratedChannelDetails,
    updateSlackChannelPhonenumber,
    deleteIntegratedSlackChannel,
    DisConnectToOutlook,
    ImportOutlookContacts,
    ImportContactOutlookStatus,
    UpdateOutlookImportSetting,
    getOutlookImportSetting,
    updateHubspotConfig,
    getHubspotConfig,
    updateClioConfig,
    getClioConfig,
};

// function getConsentDetails(id) {
//     return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/securefileshare/api/v1/getTeamsUser/${id}`);
// }

function updateConsentDetails(data) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/setTeamsUser`, data);
}


function updateIntegratedChannelDetails(data) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/setTeamsChannel`, data)
}

function getIntegratedChannelDetails(id) {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/getOrgChannels/${id}`)
}

function getIntegratedAllChannelDetails() {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/getAllChannels`)
}

function deleteIntegratedChannel(id) {
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/securefileshare/api/v1/deleteTeamsChannel/${id}`)
}

function testChannelIntegration(id) {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/testTeamsChannel/${id}`)
}

function getAllIntegrations(id) {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/get/integrations/${id}`)
}

function updateIntegrationStatus(data) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/add/integration`, data)
}

//clio

function disConnectClio(OrgRef, OrgId) {
    return AxiosInstance.delete(`${Config.API_URL}/api/ClioIntegration/Delete?OrgRef=${OrgRef}&OrgId=${OrgId}`)
}

function getClioToken(params, conf) {
    return AxiosInstance.post(`https://app.clio.com/oauth/token`, params, conf)
}

function updateClioConfig(data){
    return  AxiosInstance.post(`${Config.API_URL}/api/ClioIntegration/Config`,data)
}

function getClioConfig(){
    return  AxiosInstance.get(`${Config.API_URL}/api/ClioIntegration/Config`)
}

//hubspot

function disConnectHubSpot(OrgRef, OrgId) {
    return AxiosInstance.delete(`${Config.API_URL}/api/HubSpot/Delete?OrgRef=${OrgRef}&OrgId=${OrgId}`)
}

function updateHubspotConfig(data) {
    return AxiosInstance.post(`${Config.API_URL}/api/HubSpot/Config`, data)
}

function getHubspotConfig() {
    return AxiosInstance.get(`${Config.API_URL}/api/HubSpot/Config`)
}

// slack 
function getSlackIntegratedChannelDetails(OrgId) {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/get/slack/orgChannels/${OrgId}`)
}

function installSlack(data) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/set/slack/installation`, data)
}

function updateSlackChannelPhonenumber(data) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/link/slack/phoneNumber`, data)
}

function testSlackChannelIntegration(id) {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/send/slack/testMessage/${id}`)
}

function deleteIntegratedSlackChannel(id) {
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/falkon/notify/api/v1/remove/slack/integration/${id}`)
}

//Outlook
function DisConnectToOutlook() {
    return AxiosInstance.delete(`${Config.API_URL}/api/Outlook/Delete`)
}
function ImportOutlookContacts() {
    return AxiosInstance.post(`${Config.API_URL}/api/Outlook/ImportContacts`)
}
function ImportContactOutlookStatus() {
    return AxiosInstance.get(`${Config.API_URL}/api/Outlook/Status`)
}

function UpdateOutlookImportSetting(data) {
    return AxiosInstance.post(`${Config.API_URL}/api/Outlook/ImportSetting`, data)
}

function getOutlookImportSetting() {
    return AxiosInstance.get(`${Config.API_URL}/api/Outlook/ImportSetting`)
}


